// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import SafetyHookResourceViewModel from '../../../../viewModel/resource/SafetyHookResourceViewModel';
import SafetyHookResourceDTO from '../../dto/resource/SafetyHookResourceDTO';

export default abstract class SafetyHookResourceModel extends BaseModel<SafetyHookResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  * @type {int64}
  */
  get creatorId() { return this.dto.creatorId; }
  set creatorId(value) { this.dto.creatorId = value; }
  /**
  */
  get creatorName() { return this.dto.creatorName; }
  set creatorName(value) { this.dto.creatorName = value; }
  /**
  * @type {date-time}
  */
  get created() { return this.dto.created; }
  set created(value) { this.dto.created = value; }
  /**
  * @type {int64}
  */
  get modifierId() { return this.dto.modifierId; }
  set modifierId(value) { this.dto.modifierId = value; }
  /**
  */
  get modifierName() { return this.dto.modifierName; }
  set modifierName(value) { this.dto.modifierName = value; }
  /**
  * @type {date-time}
  */
  get modified() { return this.dto.modified; }
  set modified(value) { this.dto.modified = value; }
  /**
  */
  get name() { return this.dto.name; }
  set name(value) { this.dto.name = value; }
  /**
  */
  get groupName() { return this.dto.groupName; }
  set groupName(value) { this.dto.groupName = value; }
  /**
  */
  get screwType() { return this.dto.screwType; }
  set screwType(value) { this.dto.screwType = value; }
  /**
  */
  get safetyHookType() { return this.dto.safetyHookType; }
  set safetyHookType(value) { this.dto.safetyHookType = value; }
  /**
  * @type {int32}
  */
  get standardScrewThickness() { return this.dto.standardScrewThickness; }
  set standardScrewThickness(value) { this.dto.standardScrewThickness = value; }
  /**
  * @type {int32}
  */
  get standardScrewLength() { return this.dto.standardScrewLength; }
  set standardScrewLength(value) { this.dto.standardScrewLength = value; }
  /**
  * @type {int32}
  */
  get counterbattenScrewLength() { return this.dto.counterbattenScrewLength; }
  set counterbattenScrewLength(value) { this.dto.counterbattenScrewLength = value; }
  /**
  * @type {int32}
  */
  get minimumScrewDepth() { return this.dto.minimumScrewDepth; }
  set minimumScrewDepth(value) { this.dto.minimumScrewDepth = value; }
  /**
  */
  get canFastenOnCounterbatten() { return this.dto.canFastenOnCounterbatten; }
  set canFastenOnCounterbatten(value) { this.dto.canFastenOnCounterbatten = value; }
  /**
  */
  get screwConnectionMustBeDocumented() { return this.dto.screwConnectionMustBeDocumented; }
  set screwConnectionMustBeDocumented(value) { this.dto.screwConnectionMustBeDocumented = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    value = Number.parseFloat(qs.creatorid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.creatorId = value;
    this.dto.creatorName = qs.creatorname;
    this.dto.created = qs.created;
    value = Number.parseFloat(qs.modifierid);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.modifierId = value;
    this.dto.modifierName = qs.modifiername;
    this.dto.modified = qs.modified;
    this.dto.name = qs.name;
    this.dto.groupName = qs.groupname;
    this.dto.screwType = qs.screwtype;
    this.dto.safetyHookType = qs.safetyhooktype;
    value = Number.parseFloat(qs.standardscrewthickness);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.standardScrewThickness = value;
    value = Number.parseFloat(qs.standardscrewlength);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.standardScrewLength = value;
    value = Number.parseFloat(qs.counterbattenscrewlength);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.counterbattenScrewLength = value;
    value = Number.parseFloat(qs.minimumscrewdepth);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.minimumScrewDepth = value;
    value = qs.canFastenOnCounterbatten === 'true' ? true : qs.canfastenoncounterbatten;
    value = qs.canFastenOnCounterbatten === 'false' ? false : undefined;
    this.dto.canFastenOnCounterbatten = value;
    value = qs.screwConnectionMustBeDocumented === 'true' ? true : qs.screwconnectionmustbedocumented;
    value = qs.screwConnectionMustBeDocumented === 'false' ? false : undefined;
    this.dto.screwConnectionMustBeDocumented = value;
  }
}
